import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export default function OrganisationGroupsSettings() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <Row className="justify-content-center mt-5">
          <Col xxl={5} xl={6} lg={10} className="mt-4">
            <div className="cmn-card-color mt-4 pb-4 pt-4">
              <div className="student-view">
                <img src={require("../../Assets/Images/girl.png")} alt="Organisation profile" />
                <h2>Organisation Group User</h2>
                <p>Organisation Group Module</p>
                <p>Settings scaffold matching current app layout</p>
                <div className="students-dates">
                  <div>
                    <h3>Apr 16 26</h3>
                    <p>Joined</p>
                  </div>
                </div>
                <Link to="/organisations/school-details" className="cmn-pink w-50 mb-3">
                  School Details
                </Link>
                <Link to="/organisations/teacher-detail/demo" className="cmn-pink w-50 mb-3">
                  Teacher Details
                </Link>
                <Link to="/update-password" className="cmn-pink w-50 mb-3">
                  Update Password
                </Link>
                <Link
                  to="https://peerscroller.com/legal"
                  className="cmn-pink w-50"
                  target="_blank"
                >
                  Legal
                </Link>
                <button className="cmn-pink w-50 mb-3 mt-3">Logout</button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
